import { cx } from "@/components/ui/cx"

import type { TStatus } from "../form_tabs.interface"

interface IFormLineTextLineProps {
  title: string
  tabKey: number
  onClick?: (key: number) => void
  description?: string
  status?: TStatus
  activeTab?: number
}

/*
 * The stepper speaks the certainty grammar: a step not yet landed is a dashed
 * rule (provisional), a step that needs a person is a solid caution rule, and
 * a completed step is filled do. No red.
 */
const statusBarClass: Record<
  NonNullable<IFormLineTextLineProps["status"]>,
  string
> = {
  incomplete: "border-t-2 border-dashed border-ink-nontext",
  error: "border-t-(length:--border-rule-width) border-caution-500",
  warning: "border-t-(length:--border-rule-width) border-caution-500",
  complete: "border-t-(length:--border-rule-width) border-do-500",
}

const FormLineTextLine: React.FC<IFormLineTextLineProps> = ({
  title,
  tabKey,
  onClick,
  description,
  status = "incomplete",
  activeTab,
}) => {
  const handleClick = () => onClick && onClick(tabKey)

  return (
    <button
      onClick={handleClick}
      aria-current={activeTab === tabKey ? "step" : undefined}
      className="focus-visible:outline-focus-ring relative flex w-full cursor-pointer flex-col items-center justify-center pt-4 outline-none focus-visible:outline-2 focus-visible:outline-offset-2"
    >
      <div
        className={cx("absolute inset-x-0 top-0 h-0", statusBarClass[status])}
      />
      <div className={"flex w-full flex-col items-start gap-0.5 self-stretch"}>
        <p
          className={cx(
            "text-sm",
            activeTab === tabKey
              ? "text-primary font-semibold"
              : "text-secondary",
            status === "error" && "text-caution-700",
          )}
        >
          {title}
        </p>
        <p className={"text-tertiary text-start text-sm"}>{description}</p>
      </div>
    </button>
  )
}

export default FormLineTextLine
